/* tslint:disable */
/* eslint-disable */
/**
 * Product Storage API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/product-storage/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateProductSelectionDto } from '../models';
// @ts-ignore
import type { ModifySelectionDto } from '../models';
// @ts-ignore
import type { ProductSelectionCountDto } from '../models';
// @ts-ignore
import type { ProductSelectionDto } from '../models';
// @ts-ignore
import type { ProductSelectionListDto } from '../models';
// @ts-ignore
import type { ProductSelectionParamKeysDto } from '../models';
// @ts-ignore
import type { ProductSelectionParamValuesDto } from '../models';
// @ts-ignore
import type { SearchProductsRequestDto } from '../models';
// @ts-ignore
import type { UpdateProductSelectionDto } from '../models';
/**
 * ProductSelectionApi - axios parameter creator
 * @export
 */
export const ProductSelectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Добавить продукты в выборку
         * @param {number} selectionId 
         * @param {ModifySelectionDto} modifySelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerAddProducts: async (selectionId: number, modifySelectionDto: ModifySelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerAddProducts', 'selectionId', selectionId)
            // verify required parameter 'modifySelectionDto' is not null or undefined
            assertParamExists('productSelectionControllerAddProducts', 'modifySelectionDto', modifySelectionDto)
            const localVarPath = `/product-selection/addProducts/{selectionId}`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifySelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создание выборки
         * @param {CreateProductSelectionDto} createProductSelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerCreate: async (createProductSelectionDto: CreateProductSelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductSelectionDto' is not null or undefined
            assertParamExists('productSelectionControllerCreate', 'createProductSelectionDto', createProductSelectionDto)
            const localVarPath = `/product-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductSelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить выборку
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerDeleteSelection: async (selectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerDeleteSelection', 'selectionId', selectionId)
            const localVarPath = `/product-selection/{selectionId}`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заполнение выборки по фильтрам поиска
         * @param {number} selectionId 
         * @param {number} count 
         * @param {SearchProductsRequestDto} searchProductsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerFillByFilters: async (selectionId: number, count: number, searchProductsRequestDto: SearchProductsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerFillByFilters', 'selectionId', selectionId)
            // verify required parameter 'count' is not null or undefined
            assertParamExists('productSelectionControllerFillByFilters', 'count', count)
            // verify required parameter 'searchProductsRequestDto' is not null or undefined
            assertParamExists('productSelectionControllerFillByFilters', 'searchProductsRequestDto', searchProductsRequestDto)
            const localVarPath = `/product-selection/{selectionId}/fillByFilters`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchProductsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение всех свои выборки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение выборки по id
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetBySelectionId: async (selectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerGetBySelectionId', 'selectionId', selectionId)
            const localVarPath = `/product-selection/{selectionId}`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает DISTINCT `Property.key` по всем товарам выборки, отсортированные по алфавиту (Postgres collation). Используется в UI маппинга для Avito-фида.
         * @summary Уникальные ключи свойств товаров выборки
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetParamKeys: async (selectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerGetParamKeys', 'selectionId', selectionId)
            const localVarPath = `/product-selection/{selectionId}/paramKeys`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Источник autocomplete для UI маппинга raw-значений в Avito-формате (export-api). Возвращает уникальные `Property.value` товаров выборки, у которых `Property.key` совпадает с одним из переданных query-параметров `key`. Дедупликация — first-wins по `productId ASC` (сохраняется оригинальное написание первого встретившегося значения). Сортировка — Intl.Collator(\"ru\").
         * @summary Уникальные значения свойств товаров выборки по заданным ключам
         * @param {number} selectionId 
         * @param {Array<string>} key Ключи свойств товаров. Параметр повторяемый: ?key&#x3D;Цвет&amp;key&#x3D;Color. От 1 до 32 значений, длина каждого ≤ 256 символов.
         * @param {string} [query] Server-side substring-фильтр по value (case-insensitive если caseSensitive&#x3D;false).
         * @param {number} [limit] Максимум значений в ответе.
         * @param {boolean} [caseSensitive] Учитывать регистр при дедупликации значений и сравнении ключей. По умолчанию false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetParamValues: async (selectionId: number, key: Array<string>, query?: string, limit?: number, caseSensitive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerGetParamValues', 'selectionId', selectionId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('productSelectionControllerGetParamValues', 'key', key)
            const localVarPath = `/product-selection/{selectionId}/paramValues`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (key) {
                localVarQueryParameter['key'] = key;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (caseSensitive !== undefined) {
                localVarQueryParameter['caseSensitive'] = caseSensitive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение кол-ва товаров в выборке
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetProductsCount: async (selectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerGetProductsCount', 'selectionId', selectionId)
            const localVarPath = `/product-selection/{selectionId}/count`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить продукты из выборки
         * @param {number} selectionId 
         * @param {ModifySelectionDto} modifySelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerRemoveProducts: async (selectionId: number, modifySelectionDto: ModifySelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerRemoveProducts', 'selectionId', selectionId)
            // verify required parameter 'modifySelectionDto' is not null or undefined
            assertParamExists('productSelectionControllerRemoveProducts', 'modifySelectionDto', modifySelectionDto)
            const localVarPath = `/product-selection/removeProducts/{selectionId}`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifySelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновление выборки
         * @param {number} selectionId 
         * @param {UpdateProductSelectionDto} updateProductSelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerUpdate: async (selectionId: number, updateProductSelectionDto: UpdateProductSelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('productSelectionControllerUpdate', 'selectionId', selectionId)
            // verify required parameter 'updateProductSelectionDto' is not null or undefined
            assertParamExists('productSelectionControllerUpdate', 'updateProductSelectionDto', updateProductSelectionDto)
            const localVarPath = `/product-selection/{selectionId}`
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductSelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSelectionApi - functional programming interface
 * @export
 */
export const ProductSelectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductSelectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Добавить продукты в выборку
         * @param {number} selectionId 
         * @param {ModifySelectionDto} modifySelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerAddProducts(selectionId: number, modifySelectionDto: ModifySelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerAddProducts(selectionId, modifySelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerAddProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создание выборки
         * @param {CreateProductSelectionDto} createProductSelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerCreate(createProductSelectionDto: CreateProductSelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerCreate(createProductSelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить выборку
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerDeleteSelection(selectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerDeleteSelection(selectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerDeleteSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заполнение выборки по фильтрам поиска
         * @param {number} selectionId 
         * @param {number} count 
         * @param {SearchProductsRequestDto} searchProductsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerFillByFilters(selectionId: number, count: number, searchProductsRequestDto: SearchProductsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerFillByFilters(selectionId, count, searchProductsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerFillByFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение всех свои выборки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductSelectionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение выборки по id
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerGetBySelectionId(selectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerGetBySelectionId(selectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerGetBySelectionId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает DISTINCT `Property.key` по всем товарам выборки, отсортированные по алфавиту (Postgres collation). Используется в UI маппинга для Avito-фида.
         * @summary Уникальные ключи свойств товаров выборки
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerGetParamKeys(selectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionParamKeysDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerGetParamKeys(selectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerGetParamKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Источник autocomplete для UI маппинга raw-значений в Avito-формате (export-api). Возвращает уникальные `Property.value` товаров выборки, у которых `Property.key` совпадает с одним из переданных query-параметров `key`. Дедупликация — first-wins по `productId ASC` (сохраняется оригинальное написание первого встретившегося значения). Сортировка — Intl.Collator(\"ru\").
         * @summary Уникальные значения свойств товаров выборки по заданным ключам
         * @param {number} selectionId 
         * @param {Array<string>} key Ключи свойств товаров. Параметр повторяемый: ?key&#x3D;Цвет&amp;key&#x3D;Color. От 1 до 32 значений, длина каждого ≤ 256 символов.
         * @param {string} [query] Server-side substring-фильтр по value (case-insensitive если caseSensitive&#x3D;false).
         * @param {number} [limit] Максимум значений в ответе.
         * @param {boolean} [caseSensitive] Учитывать регистр при дедупликации значений и сравнении ключей. По умолчанию false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerGetParamValues(selectionId: number, key: Array<string>, query?: string, limit?: number, caseSensitive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionParamValuesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerGetParamValues(selectionId, key, query, limit, caseSensitive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerGetParamValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение кол-ва товаров в выборке
         * @param {number} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerGetProductsCount(selectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerGetProductsCount(selectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerGetProductsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить продукты из выборки
         * @param {number} selectionId 
         * @param {ModifySelectionDto} modifySelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerRemoveProducts(selectionId: number, modifySelectionDto: ModifySelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerRemoveProducts(selectionId, modifySelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerRemoveProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновление выборки
         * @param {number} selectionId 
         * @param {UpdateProductSelectionDto} updateProductSelectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSelectionControllerUpdate(selectionId: number, updateProductSelectionDto: UpdateProductSelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSelectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSelectionControllerUpdate(selectionId, updateProductSelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductSelectionApi.productSelectionControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductSelectionApi - factory interface
 * @export
 */
export const ProductSelectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductSelectionApiFp(configuration)
    return {
        /**
         * 
         * @summary Добавить продукты в выборку
         * @param {ProductSelectionApiProductSelectionControllerAddProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerAddProducts(requestParameters: ProductSelectionApiProductSelectionControllerAddProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionDto> {
            return localVarFp.productSelectionControllerAddProducts(requestParameters.selectionId, requestParameters.modifySelectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создание выборки
         * @param {ProductSelectionApiProductSelectionControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerCreate(requestParameters: ProductSelectionApiProductSelectionControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionDto> {
            return localVarFp.productSelectionControllerCreate(requestParameters.createProductSelectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить выборку
         * @param {ProductSelectionApiProductSelectionControllerDeleteSelectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerDeleteSelection(requestParameters: ProductSelectionApiProductSelectionControllerDeleteSelectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.productSelectionControllerDeleteSelection(requestParameters.selectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заполнение выборки по фильтрам поиска
         * @param {ProductSelectionApiProductSelectionControllerFillByFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerFillByFilters(requestParameters: ProductSelectionApiProductSelectionControllerFillByFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionDto> {
            return localVarFp.productSelectionControllerFillByFilters(requestParameters.selectionId, requestParameters.count, requestParameters.searchProductsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение всех свои выборки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductSelectionListDto>> {
            return localVarFp.productSelectionControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение выборки по id
         * @param {ProductSelectionApiProductSelectionControllerGetBySelectionIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetBySelectionId(requestParameters: ProductSelectionApiProductSelectionControllerGetBySelectionIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionDto> {
            return localVarFp.productSelectionControllerGetBySelectionId(requestParameters.selectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает DISTINCT `Property.key` по всем товарам выборки, отсортированные по алфавиту (Postgres collation). Используется в UI маппинга для Avito-фида.
         * @summary Уникальные ключи свойств товаров выборки
         * @param {ProductSelectionApiProductSelectionControllerGetParamKeysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetParamKeys(requestParameters: ProductSelectionApiProductSelectionControllerGetParamKeysRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionParamKeysDto> {
            return localVarFp.productSelectionControllerGetParamKeys(requestParameters.selectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Источник autocomplete для UI маппинга raw-значений в Avito-формате (export-api). Возвращает уникальные `Property.value` товаров выборки, у которых `Property.key` совпадает с одним из переданных query-параметров `key`. Дедупликация — first-wins по `productId ASC` (сохраняется оригинальное написание первого встретившегося значения). Сортировка — Intl.Collator(\"ru\").
         * @summary Уникальные значения свойств товаров выборки по заданным ключам
         * @param {ProductSelectionApiProductSelectionControllerGetParamValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetParamValues(requestParameters: ProductSelectionApiProductSelectionControllerGetParamValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionParamValuesDto> {
            return localVarFp.productSelectionControllerGetParamValues(requestParameters.selectionId, requestParameters.key, requestParameters.query, requestParameters.limit, requestParameters.caseSensitive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение кол-ва товаров в выборке
         * @param {ProductSelectionApiProductSelectionControllerGetProductsCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerGetProductsCount(requestParameters: ProductSelectionApiProductSelectionControllerGetProductsCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionCountDto> {
            return localVarFp.productSelectionControllerGetProductsCount(requestParameters.selectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить продукты из выборки
         * @param {ProductSelectionApiProductSelectionControllerRemoveProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerRemoveProducts(requestParameters: ProductSelectionApiProductSelectionControllerRemoveProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionDto> {
            return localVarFp.productSelectionControllerRemoveProducts(requestParameters.selectionId, requestParameters.modifySelectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновление выборки
         * @param {ProductSelectionApiProductSelectionControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSelectionControllerUpdate(requestParameters: ProductSelectionApiProductSelectionControllerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSelectionDto> {
            return localVarFp.productSelectionControllerUpdate(requestParameters.selectionId, requestParameters.updateProductSelectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productSelectionControllerAddProducts operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerAddProductsRequest
 */
export interface ProductSelectionApiProductSelectionControllerAddProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerAddProducts
     */
    readonly selectionId: number

    /**
     * 
     * @type {ModifySelectionDto}
     * @memberof ProductSelectionApiProductSelectionControllerAddProducts
     */
    readonly modifySelectionDto: ModifySelectionDto
}

/**
 * Request parameters for productSelectionControllerCreate operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerCreateRequest
 */
export interface ProductSelectionApiProductSelectionControllerCreateRequest {
    /**
     * 
     * @type {CreateProductSelectionDto}
     * @memberof ProductSelectionApiProductSelectionControllerCreate
     */
    readonly createProductSelectionDto: CreateProductSelectionDto
}

/**
 * Request parameters for productSelectionControllerDeleteSelection operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerDeleteSelectionRequest
 */
export interface ProductSelectionApiProductSelectionControllerDeleteSelectionRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerDeleteSelection
     */
    readonly selectionId: number
}

/**
 * Request parameters for productSelectionControllerFillByFilters operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerFillByFiltersRequest
 */
export interface ProductSelectionApiProductSelectionControllerFillByFiltersRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerFillByFilters
     */
    readonly selectionId: number

    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerFillByFilters
     */
    readonly count: number

    /**
     * 
     * @type {SearchProductsRequestDto}
     * @memberof ProductSelectionApiProductSelectionControllerFillByFilters
     */
    readonly searchProductsRequestDto: SearchProductsRequestDto
}

/**
 * Request parameters for productSelectionControllerGetBySelectionId operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerGetBySelectionIdRequest
 */
export interface ProductSelectionApiProductSelectionControllerGetBySelectionIdRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerGetBySelectionId
     */
    readonly selectionId: number
}

/**
 * Request parameters for productSelectionControllerGetParamKeys operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerGetParamKeysRequest
 */
export interface ProductSelectionApiProductSelectionControllerGetParamKeysRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerGetParamKeys
     */
    readonly selectionId: number
}

/**
 * Request parameters for productSelectionControllerGetParamValues operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerGetParamValuesRequest
 */
export interface ProductSelectionApiProductSelectionControllerGetParamValuesRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerGetParamValues
     */
    readonly selectionId: number

    /**
     * Ключи свойств товаров. Параметр повторяемый: ?key&#x3D;Цвет&amp;key&#x3D;Color. От 1 до 32 значений, длина каждого ≤ 256 символов.
     * @type {Array<string>}
     * @memberof ProductSelectionApiProductSelectionControllerGetParamValues
     */
    readonly key: Array<string>

    /**
     * Server-side substring-фильтр по value (case-insensitive если caseSensitive&#x3D;false).
     * @type {string}
     * @memberof ProductSelectionApiProductSelectionControllerGetParamValues
     */
    readonly query?: string

    /**
     * Максимум значений в ответе.
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerGetParamValues
     */
    readonly limit?: number

    /**
     * Учитывать регистр при дедупликации значений и сравнении ключей. По умолчанию false.
     * @type {boolean}
     * @memberof ProductSelectionApiProductSelectionControllerGetParamValues
     */
    readonly caseSensitive?: boolean
}

/**
 * Request parameters for productSelectionControllerGetProductsCount operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerGetProductsCountRequest
 */
export interface ProductSelectionApiProductSelectionControllerGetProductsCountRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerGetProductsCount
     */
    readonly selectionId: number
}

/**
 * Request parameters for productSelectionControllerRemoveProducts operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerRemoveProductsRequest
 */
export interface ProductSelectionApiProductSelectionControllerRemoveProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerRemoveProducts
     */
    readonly selectionId: number

    /**
     * 
     * @type {ModifySelectionDto}
     * @memberof ProductSelectionApiProductSelectionControllerRemoveProducts
     */
    readonly modifySelectionDto: ModifySelectionDto
}

/**
 * Request parameters for productSelectionControllerUpdate operation in ProductSelectionApi.
 * @export
 * @interface ProductSelectionApiProductSelectionControllerUpdateRequest
 */
export interface ProductSelectionApiProductSelectionControllerUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionApiProductSelectionControllerUpdate
     */
    readonly selectionId: number

    /**
     * 
     * @type {UpdateProductSelectionDto}
     * @memberof ProductSelectionApiProductSelectionControllerUpdate
     */
    readonly updateProductSelectionDto: UpdateProductSelectionDto
}

/**
 * ProductSelectionApi - object-oriented interface
 * @export
 * @class ProductSelectionApi
 * @extends {BaseAPI}
 */
export class ProductSelectionApi extends BaseAPI {
    /**
     * 
     * @summary Добавить продукты в выборку
     * @param {ProductSelectionApiProductSelectionControllerAddProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerAddProducts(requestParameters: ProductSelectionApiProductSelectionControllerAddProductsRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerAddProducts(requestParameters.selectionId, requestParameters.modifySelectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создание выборки
     * @param {ProductSelectionApiProductSelectionControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerCreate(requestParameters: ProductSelectionApiProductSelectionControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerCreate(requestParameters.createProductSelectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить выборку
     * @param {ProductSelectionApiProductSelectionControllerDeleteSelectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerDeleteSelection(requestParameters: ProductSelectionApiProductSelectionControllerDeleteSelectionRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerDeleteSelection(requestParameters.selectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заполнение выборки по фильтрам поиска
     * @param {ProductSelectionApiProductSelectionControllerFillByFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerFillByFilters(requestParameters: ProductSelectionApiProductSelectionControllerFillByFiltersRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerFillByFilters(requestParameters.selectionId, requestParameters.count, requestParameters.searchProductsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение всех свои выборки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerGetAll(options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение выборки по id
     * @param {ProductSelectionApiProductSelectionControllerGetBySelectionIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerGetBySelectionId(requestParameters: ProductSelectionApiProductSelectionControllerGetBySelectionIdRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerGetBySelectionId(requestParameters.selectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает DISTINCT `Property.key` по всем товарам выборки, отсортированные по алфавиту (Postgres collation). Используется в UI маппинга для Avito-фида.
     * @summary Уникальные ключи свойств товаров выборки
     * @param {ProductSelectionApiProductSelectionControllerGetParamKeysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerGetParamKeys(requestParameters: ProductSelectionApiProductSelectionControllerGetParamKeysRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerGetParamKeys(requestParameters.selectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Источник autocomplete для UI маппинга raw-значений в Avito-формате (export-api). Возвращает уникальные `Property.value` товаров выборки, у которых `Property.key` совпадает с одним из переданных query-параметров `key`. Дедупликация — first-wins по `productId ASC` (сохраняется оригинальное написание первого встретившегося значения). Сортировка — Intl.Collator(\"ru\").
     * @summary Уникальные значения свойств товаров выборки по заданным ключам
     * @param {ProductSelectionApiProductSelectionControllerGetParamValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerGetParamValues(requestParameters: ProductSelectionApiProductSelectionControllerGetParamValuesRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerGetParamValues(requestParameters.selectionId, requestParameters.key, requestParameters.query, requestParameters.limit, requestParameters.caseSensitive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение кол-ва товаров в выборке
     * @param {ProductSelectionApiProductSelectionControllerGetProductsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerGetProductsCount(requestParameters: ProductSelectionApiProductSelectionControllerGetProductsCountRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerGetProductsCount(requestParameters.selectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить продукты из выборки
     * @param {ProductSelectionApiProductSelectionControllerRemoveProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerRemoveProducts(requestParameters: ProductSelectionApiProductSelectionControllerRemoveProductsRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerRemoveProducts(requestParameters.selectionId, requestParameters.modifySelectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновление выборки
     * @param {ProductSelectionApiProductSelectionControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSelectionApi
     */
    public productSelectionControllerUpdate(requestParameters: ProductSelectionApiProductSelectionControllerUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProductSelectionApiFp(this.configuration).productSelectionControllerUpdate(requestParameters.selectionId, requestParameters.updateProductSelectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

